import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

function YouTubeFollow() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const API_KEY = "AIzaSyBUiHMNWSUiArO0Bwvo_uYgQAZOmbrIpiQ";
    const CHANNEL_ID = "UCRe-pj3HPYeukBbLyYBo4HQ";

    fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet,id&channelId=${CHANNEL_ID}&maxResults=8&order=date&type=video&key=${API_KEY}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.items) {
          const parsedVideos = data.items.map((item) => ({
            title: item.snippet.title,
            link: `https://www.youtube.com/watch?v=${item.id.videoId}`,
            thumbnail: item.snippet.thumbnails.high.url,
          }));

          setVideos(parsedVideos);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <section className="categories-con position-relative">
      <div className="container">
        {/* TITLE */}
                <motion.div
                  className="text-center categories_content"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <h2>
                    Follow Us on <span>YouTube</span>
                  </h2>
                    <p>Watch our latest Festivo Gelato videos and updates</p>
        </motion.div>

        <div className="youtube-gallery">
          {videos.map((video, index) => (
            <motion.a
              key={index}
              href={video.link}
              target="_blank"
              rel="noreferrer"
              className="video-card"
              whileHover={{ scale: 1.05 }}
            >
              <img src={video.thumbnail} alt={video.title} />

              <div className="play-icon">
                <i className="fa-brands fa-youtube"></i>
              </div>

              <p>{video.title}</p>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default YouTubeFollow;